<template>
    <v-row dense class="">
        <v-col cols="10" class="">
            <v-row justify="center">
                <h5>秘密保持誓約書</h5>
            </v-row>
            <hr class="dashed my-1">
            <v-row dense no-gutter justify="center" class="mx-1">
                <v-col cols="6" class="">
                    <v-row justify="center" align="center">
                        <span class="caption mx-1">送信済み</span>
                        <v-checkbox v-model="ndaStatus.sent"></v-checkbox>
                    </v-row>
                </v-col>
                <v-col cols="6">
                    <v-row justify="center" align="center">
                        <span class="caption mx-1">契約済み</span>
                        <v-checkbox v-model="ndaStatus.signed"></v-checkbox>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="2" class="">
            <v-row justify="center">
                <h5>誓約書作成</h5>
            </v-row>
            <hr class="dashed my-1">
            <v-row justify="center" align="center">
                <v-col cols="12">
                    <v-row justify="center">
                        <v-btn x-small class="mt-3" @click="downloadNDA()">PDFを作成</v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
/* eslint-disable no-console */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
    name:'nda',
    props:[
        'researcher',
    ],
    data(){
        return{
            ndaStatus:{
                sent:false,
                signed:false,
            }
        }
    },
    methods:{
        downloadNDA(){
            pdfMake.fonts = {
                GenShin: {
                    normal: 'GenShinGothic-Normal-Sub.ttf',
                    bold: 'GenShinGothic-Normal-Sub.ttf',
                    italics: 'GenShinGothic-Normal-Sub.ttf',
                    bolditalics: 'GenShinGothic-Normal-Sub.ttf',
                },
            };
            const defaultStyle = 'GenShin';

            // PDF出力する内容の定義
            const dateOfCreation = new Date();
            const docDefinition = {
                content: [
                    {
                        text: `\n日付 ${' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+dateOfCreation.getFullYear()}年${dateOfCreation.getMonth()+1}月${dateOfCreation.getDate()}日`,
                        margin: [ 240, 10, 0, 10 ],
                        style: 'text',
                        alignment: 'left'
                    },
                    {
                        text: '株式会社ＴＰＯ　御中',
                        margin: [ 0, 10, 0, 10 ],
                        style: 'text',
                        alignment: 'left'
                    },
                    {
                        text: `住所 ${' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+this.researcher.address.address}`,
                        margin: [ 240, 10, 0, 10 ],
                        style: 'text',
                        alignment: 'left'
                    },
                    {
                        text: `\n氏名 ${' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+this.researcher.name[1]+' '+this.researcher.name[0]}`,
                        margin: [ 240, 10, 0, 10 ],
                        style: 'text',
                        alignment: 'left'
                    },
                    {
                        text: '秘密保持誓約書',
                        margin: [ 0, 10, 0, 10 ],
                        style: 'header',
                        alignment: 'center'
                    },
                    {
                        text:`私は、貴社と令和${dateOfCreation.getFullYear()-2018}年${dateOfCreation.getMonth()+1}月${dateOfCreation.getDate()}日付業務委託契約(以下「原契約」)を締結するにあたり、秘密保持に関し、下記の各事項を遵守することを誓約いたします。`,
                        margin: [ 0, 10, 0, 10 ],
                        style: 'text',
                    },
                    {   
                        type:'none',
                        ol:[
                            ['\n1. 私は、原契約中及び原契約終了後を問わず、貴社の業務に関連して知り得た以下の情報(以下「秘密情報」)について、事前の貴社の書面による承諾なく、第三者に開示又は漏洩せず、また、貴社の業務以外の目的に使用いたしません。',
                                {
                                    ol:[
                                        '貴社の商品又はサービスの企画・開発・設計過程、製造過程、製造原価、価格、ノウハウ等に関する情報',
                                        '貴社の顧客又は取引先の名称・連絡先、顧客又は取引先との間の取引内容、取引予定、取引条件、取引回数その他の貴社の顧客又は取引先に関する情報',
                                        '貴社の未公開特許情報、コンピュータープログラム（ソースコードを含みます）、フローチャート、設計書、仕様書その他のプログラム関連資料',
                                        '貴社の事業計画、経営上・営業上の企画・方針、経理・財務、人事処遇に関する情報',
                                        '貴社の第三者との業務提携その他重要な取引に関する情報',
                                        '貴社及び取引先の従業員、役員、株主等の個人情報',
                                        '貴社が第三者との間において秘密保持義務を負担している情報',
                                        '貴社より提供・貸与されたパソコン、ノートパソコン、ＵＳＢメモリその他の電磁記録媒体に含まれる情報',
                                        '貴社より閲覧、照会、入力、登録等の権限を付与されたＷＥＢシステム等のログインＩＤ、パスワード情報等',
                                        'その他、貴社において秘密として管理され、又は秘密として指定された情報',
                                    ],
                                }
                            ],
                            '\n2. 私は、前項に従った貴社の承諾を得て第三者に秘密情報を開示する場合、本誓約書に定める秘密保持義務と同等の秘密保持義務を当該第三者に課し、その義務を遵守させるものとし、かつ、当該第三者においてその義務違反があった場合には、貴社に対して、当該第三者と連帯して責任を負うものとします。',
                            '\n3. 私は、原契約の業務上必要不可欠な範囲を超えて、秘密情報を複写又は複製せず、秘密情報を含む書類その他の資料(外部記録媒体及び複写物・複製物を含みます。以下同じ)を貴社外に持ち出したり、貴社外へ送信・送付したりいたしません。',
                            '\n4. 私は、貴社の承諾なく、貴社が私に貸与、提供又は使用承諾するパソコン、ノートパソコン等において、ファイル交換ソフト(Winnyを含むがこれに限られません)その他貴社が承諾するソフトウェア以外のソフトウェアをインストールしたり、使用したりいたしません。なお、私は、貴社が貸与又は提供する以外のパソコン、ノートパソコン等を貴社の業務に使用する場合には、事前に貴社の承諾を得るとともに、貴社が指定する条件に従います。',
                            '\n5. 私は、他社の営業秘密を当該他社の承諾なくして貴社に開示せず、かつ、貴社の業務に使用いたしません。また、私は他社において完成させた職務発明等(あれば)について、貴社名義で出願をさせません。',
                            '\n6. 私は、貴社から業務を受託し、その業務を遂行するに際して支障となり得る競業避止義務等の義務を一切負担していないことを確認いたします。',
                            '\n7. 私は、原契約終了後、その時点で私が管理・保持している秘密情報(秘密情報を含む電磁記録媒体その他の記録媒体の一切を含みます)について、貴社の指示に従い、貴社に返還し、又は廃棄・削除・消去いたします。なお、原契約終了前に貴社から要求があった場合も同様とします。',
                            '\n8. 私は、原契約期間中及び原契約終了後１年間は、貴社が業務を行う都道府県内において、貴社の業務と同一又は類似の業務に従事せず、また、当該業務に従事する事業者への就職、役員就任、出資等を行いません。',
                            '\n9. 私は、私が本誓約書によって貴社に対して法的義務を負担すること及び私が本誓約書に違反した場合には、貴社に対して法的責任を負担することを十分に理解しています。私は、万一、本誓約書に違反した場合には、貴社から差止め等の請求を受けることに一切異議はなく、かつ、貴社及びその関係者が被った一切の損害を賠償いたします。'
                        ]
                    },
                    {
                        text: '以上',
                        margin: [ 0, 10, 0, 10 ],
                        style: 'text',
                        alignment: 'right'
                    },

                ],
                defaultStyle: {
                    font: defaultStyle,
                },
                styles: {
                    header: {
                        fontSize: 18,
                    },
                    subheader: {
                        fontSize: 10.5,
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                },
            };

            // pdfMakeでのPDF出力
            pdfMake.createPdf(docDefinition).open();
        }
    },
}
</script>>